var _line, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleSidedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 20,
    viewBox: "0 0 400 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 390,
    y2: 10,
    stroke: "currentColor",
    strokeWidth: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "20,5 10,10 20,15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "380,5 390,10 380,15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleSidedArrow);
export default __webpack_public_path__ + "static/media/double_sided_arrow.094a3e768c6de6cf8113b860baf32506.svg";
export { ForwardRef as ReactComponent };